var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArwOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85195 0.20936C4.72697 0.334379 4.65676 0.503919 4.65676 0.680696C4.65676 0.857472 4.72697 1.02701 4.85195 1.15203L7.04729 3.34736H0.656619C0.479807 3.34736 0.310236 3.4176 0.185211 3.54262C0.0601864 3.66765 -0.0100527 3.83722 -0.0100527 4.01403C-0.0100527 4.19084 0.0601864 4.36041 0.185211 4.48544C0.310236 4.61046 0.479807 4.6807 0.656619 4.6807H7.04729L4.85193 6.87603C4.73062 7.00179 4.66352 7.17015 4.6651 7.34488C4.66667 7.51961 4.73678 7.68674 4.86034 7.8103C4.9839 7.93385 5.15102 8.00396 5.32575 8.00553C5.50048 8.0071 5.66885 7.94 5.7946 7.81869L9.12795 4.48538L9.12929 4.48405C9.19101 4.42233 9.23997 4.34905 9.27338 4.26841C9.30678 4.18777 9.32397 4.10133 9.32397 4.01405C9.32397 3.92676 9.30678 3.84033 9.27338 3.75968C9.23997 3.67904 9.19101 3.60577 9.12929 3.54405L9.12795 3.54272L5.79462 0.209344C5.6696 0.0843677 5.50006 0.0141602 5.32329 0.0141602C5.14652 0.0141602 4.97698 0.0843677 4.85196 0.209344L4.85195 0.20936Z",
    fill: "#566FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArwOrange);
export default __webpack_public_path__ + "static/media/right_arw_orange.ea18df60f0932cec4c4a11a24c9bd5ce.svg";
export { ForwardRef as ReactComponent };